// Single source of truth for the backend base URL.
// Resolves at runtime so a missing build-time REACT_APP_BACKEND_URL can never
// produce fetches to "/undefined/api/..." (the production white-screen cause).
function resolveBackendUrl() {
  const fromEnv = process.env.REACT_APP_BACKEND_URL;
  if (fromEnv && fromEnv !== "undefined" && fromEnv !== "null") {
    return String(fromEnv).replace(/\/+$/, "");
  }
  // Same-origin fallback: in production the backend is served behind the same
  // host via the "/api" ingress prefix, so window.origin + "/api" is correct.
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return "";
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
export default BACKEND_URL;
